import { render, staticRenderFns } from "./TxToSaveParams.vue?vue&type=template&id=32150121&scoped=true&"
import script from "./TxToSaveParams.vue?vue&type=script&lang=js&"
export * from "./TxToSaveParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32150121",
  null
  
)

export default component.exports